import { useState } from 'react';
import { useI18n } from '../../i18n';
import { Icon } from '../../ui';
import { EditDetailsDialog, useDetails } from './CompanyDetailsCard';
import { useCurrentCompany } from './hooks';

/**
 * On every page of a read-only company, for everybody in it (TF-113): why nothing can be changed, and
 * until when. Its owners get the details form from here - adding the number ends it at once. And for
 * one person over the plan's limit of active people (TF-116): why, and whom to ask.
 */
export function ReadOnlyBanner() {
  const { t, tp, date } = useI18n();
  const { tenantId, company } = useCurrentCompany();
  const [editing, setEditing] = useState(false);
  const isOwner = company?.role === 'owner';
  const until = company?.status === 'active' ? company.readOnlyUntil : null;
  const details = useDetails(tenantId ?? '', Boolean(until && isOwner));
  if (!tenantId || !company) return null;
  // Only me, over the plan's limit of active people (TF-116).
  if (!until && company.status === 'active' && company.memberState === 'read_only') {
    return (
      <section className="banner banner-warning read-only-banner" aria-label={t('readOnly.title')} data-testid="read-only-banner">
        <Icon name="lock" className="icon-lead" />
        <p className="grow m-0">{tp('memberLimit.banner', company.memberLimit ?? 0, { company: company.name })}</p>
      </section>
    );
  }
  if (!until) return null;
  return (
    <section className="banner banner-danger read-only-banner" aria-label={t('readOnly.title')} data-testid="read-only-banner">
      <Icon name="lock" className="icon-lead" />
      <p className="grow m-0">
        <strong>{t('readOnly.banner', { date: date(until) })}</strong> {isOwner ? t('readOnly.ownerHint') : t('readOnly.askOwner')}
      </p>
      {isOwner && (
        <button type="button" className="btn btn-sm btn-filled" disabled={!details.data} onClick={() => setEditing(true)}>
          {t('readOnly.addNumber')}
        </button>
      )}
      {editing && details.data && <EditDetailsDialog tenantId={tenantId} details={details.data.details} open={editing} onOpenChange={setEditing} />}
    </section>
  );
}
